/* eslint-disable */
// Modified: 2019-02-24.
// param _this: is this of vue called to here, using call function at vue
//param nameFuntion :  is name function wanna call after openMapServiceAsp finish
import axios from "assets/js/request";
import common from "assets/js/common";
import UrlConstants from 'assets/const/UrlConstants';

const MAP_URL = UrlConstants.REST + UrlConstants.MAP;
var sessionId = '';
var mapInfo = {
    
    /*
    *   受取場所選択地図サービス(ASP)を開く
    */
    openMapServiceAsp: function(_this,nameFuntion,machineKbn, address, zip){
        var reqModel = {};
        reqModel.machineKbn = machineKbn;
        axios.post(MAP_URL+ UrlConstants.PROPERTIES, reqModel).then((response) => {
            var url = response.data.searchMapUrl;
            var corpId = response.data.corpId;
            sessionId = response.data.sessionId;
            
            // 受取場所地図画面（ASP）URLの生成
            url = url.replace("{address}",address).replace("{zip}",zip).replace("{corpId}",corpId).replace("{key}",sessionId);
            var winOpen = window.open(url,'popUp','toolbar=no,location=no,titlebar=nm,status=no,menubar=no,height=600,width=800,resizable=yes');
            _this[nameFuntion](winOpen);
        }).catch(function(error) {
            common.errorAPI(error);
        });
        

    },
    /*
    * ※受取場所地図画面（ASP）が閉じられたタイミングで呼び出す
    */
    getReceiptPlace: function(_this,nameFuntion,machineKbn, binsyuCd){
        var reqModel = {};
        reqModel.machineKbn = machineKbn;
        reqModel.binsyuCd = binsyuCd;
        reqModel.sessionId = sessionId;
        axios.post(MAP_URL+UrlConstants.GET_MAP_INFO_2, reqModel).then(function(response) {
            _this[nameFuntion](response);
        }).catch(function(error) {
            common.errorAPI(error);
        });

    },
    /*
    * ※受取場所地図画面（ASP）が閉じられたタイミングで呼び出す
    */
    getReceiptPlace2: function(_this,nameFuntion,machineKbn, kessaiCd, binsyuCd){
        var reqModel = {};
        reqModel.machineKbn = machineKbn;
        reqModel.kessaiCd = kessaiCd;
        reqModel.binsyuCd = binsyuCd;
        axios.post(MAP_URL+UrlConstants.GET_MAP_INFO_3, reqModel).then(function(response) {
            _this[nameFuntion](response);
        }).catch(function(error) {
            common.errorAPI(error);
        });

    }
} 



export default mapInfo